'use strict';

import Select from "./filter/Select";
import SpinWidget from "../SpinWidget";
import Loading from "../Loading";
import AircraftCard from "./AircraftCard";
import AircraftSlider from "./AircraftSlider";
import MovableRouteCards from "./routes/MovableRouteCards";
import MovableRouteCard from "./routes/MovableRouteCard";

export default function ItemDetail({
    item = {},
    imageSize = '',
    showForm = false,
    averagePrice,
    showPriceModal= false,
    formDataInit = {},
    errors = {},
    isSubmitting = false,
    buttons = ['submit'],
    onSubmit,
    onShowBarometerClick,
}) {
    const {id, aircraft, routes, prices, tags, pdf_url} = item
    const [hasServerErrors, setHasServerErrors] = React.useState(false)
    
    let formData = {}

    const handleSubmit = () => {
        onSubmit && onSubmit(showForm ? formData : undefined)
    }
    
    const handleFormChange = (data) => {
        formData = data
    }

    React.useEffect(() => {
        const allowedKeys = ['date', 'time', 'seats'];
        if (errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
            const extraKeys = Object.keys(errors).filter(key => !allowedKeys.includes(key));
            if (extraKeys.length > 0) {
                setHasServerErrors(true)
                extraKeys.map(e => console.error(errors[e]))
            }
        } else {
            setHasServerErrors(false)
        }
    }, [errors])

    const images = aircraft.images && aircraft.images[imageSize] ? aircraft.images[imageSize] : []

    let departDate, departDateFrom, departDateTo = null;
    if (showForm && routes && routes.length > 0 && routes[0]) {
        departDate = routes[0].departDate
        departDateFrom = routes[0].departDateFrom
        departDateTo = routes[0].departDateTo
    }

    const isPriceBelowAnnual = () => {
        if (!averagePrice || !prices.price || isNaN(averagePrice) || isNaN(prices.price)) return false;
        return prices.price < averagePrice
    }
    
    const showBarometerButton = () => {
        return !!showPriceModal && isPriceBelowAnnual()
    }

    const handleBarometerClick = () => {
        onShowBarometerClick && onShowBarometerClick()
    }

    return <React.Fragment>
        <div className="offer-modal__row">
            
            <AircraftCard aircraft={aircraft} tags={tags} />
            
            {images && images.length > 0 && <div className="offer-modal__slider">
                <AircraftSlider images={images} keyPrefix={id}/>
            </div>}
        </div>
        <div className="offer-modal__bottom">

            {(routes || []).length === 1 && (routes || []).map((route, index) => <MovableRouteCard key={`route${index}`} route={route} index={1} />)}
            {(routes || []).length > 1 && <MovableRouteCards routes={routes} />}

            <div className="offer-modal__control">
                <div className="offer-control__text">
                    <a href="#termsModalNoButton" data-fancybox className="offer-control__link">
                        {tMsg('Условия бронирования и отмены рейса')}
                    </a>
                </div>
                <div className="offer-control__bottom">
                    <div className="offer-control__price">

                        {showBarometerButton() && <div className="offer-control__price">
                            <a type='button' 
                               className="flight-price__graph-link offer-control__price-value el-tooltip" 
                               data-tooltip={tMsg('Цена ниже среднегодовой')} 
                               onClick={handleBarometerClick}
                            >
                                <i className="icon-down4"></i>
                                {prices.prefix}{prices.price.formatPrice(prices.currency.code)}
                            </a>
                        </div>}

                        {!showBarometerButton() && <div className="offer-control__price-value">
                            {prices.prefix}{prices.price.formatPrice(prices.currency.code)}
                        </div>}

                        {showForm && <Form
                            departDate={departDate}
                            departDateFrom={departDateFrom}
                            departDateTo={departDateTo}
                            maxSeats={aircraft.params.seats}
                            errors={errors}
                            formDataInit={formDataInit}
                            onChange={(data) => handleFormChange(data)}
                        />}

                    </div>

                    <div className="offer-control__btn flex-column mt-auto">
                        {hasServerErrors && <div className="offer_error">{tMsg('Произошла ошибка сервера')}</div>}
                        {buttons.includes('pdf') && <a href={pdf_url} target="_blank" className="button button-white">
                            {tMsg('Предложение')} <span>(PDF)</span>
                        </a>}
                        {buttons.includes('submit') && <button disabled={isSubmitting} className="button button-base" onClick={handleSubmit}>
                            {tMsg('Получить предложение')}
                        </button>}
                    </div>
                </div>
            </div>
        </div>

        <Loading active={isSubmitting} absolute />
        
    </React.Fragment>
}

function Form({departDate = null, departDateFrom = null, departDateTo = null, maxSeats = 10, errors = {}, formDataInit = {}, onChange}) {
    
    const [dateList, setDateList] = React.useState([])
    const [timeList, setTimeList] = React.useState([])
    const [dateValue, setDateValue] = React.useState('')
    const [timeValue, setTimeValue] = React.useState('12:00')
    const [seatsValue, setSeatsValue] = React.useState(1)

    const handleDateChange = (value) => {
        setDateValue(() => value)
    }
    const handleTimeChange = (value) => {
        setTimeValue(value)
    }
    const handleSeatsChange = (value) => {
        setSeatsValue(value)
    }
    const handleChangeValue = () => {
        onChange && onChange({
            date: dateValue,
            time: timeValue,
            seats: seatsValue,
        })
    }
    
    React.useEffect(() => {
        handleChangeValue()
    }, [dateValue, timeValue, seatsValue])
    
    const getValue = (moment) => {
        return moment.format('DD.MM.YYYY')
    }
    const getTitle = (moment) => {
        return moment.format('DD.MM.YYYY')
    }
    
    React.useEffect(() => {
        
        // ДАТЫ

        const dateList = []
        
        const depart_moment = departDate ? moment(departDate, 'DD.MM.YYYY') : null;
        const depart_from_moment = departDateFrom ? moment(departDateFrom, 'DD.MM.YYYY') : null;
        let depart_to_moment = departDateTo ? moment(departDateTo, 'DD.MM.YYYY') : null;

        if (depart_from_moment && depart_from_moment.isValid() && depart_to_moment && depart_to_moment.isValid()) {
            
            const now = moment().startOf('day')
            const depart_from_moment_actual = depart_from_moment.startOf('day').isBefore(now) ? now : depart_from_moment;
            
            if (depart_to_moment.startOf('day').isBefore(depart_from_moment_actual.startOf('day'))) {
                depart_to_moment = depart_from_moment_actual;
                console.error('Неверный диапазон');
            }
            
            handleDateChange(getTitle(depart_from_moment_actual))

            while (depart_from_moment_actual.isSameOrBefore(depart_to_moment.startOf('day'))) {
                dateList.push({
                    id: getValue(depart_from_moment_actual),
                    title: getTitle(depart_from_moment_actual)
                });
                depart_from_moment_actual.add(1, 'days');
            }
            
        } else if (depart_moment && depart_moment.isValid()) {

            handleDateChange(getTitle(depart_moment))
            dateList.push({
                id: getValue(depart_moment),
                title: getTitle(depart_moment)
            });

        }
        
        setDateList(dateList)

        
        // ВРЕМЯ
        
        const timeList = Array.from({ length: 48 }, (_, i) => {
            const hh = String(Math.floor(i / 2)).padStart(2, '0');
            const mm = (i % 2 === 0) ? '00' : '30';
            const value = hh + ':' + mm;
            return {id: value, title: value};
        });
        
        setTimeList(timeList)
        
    }, [])

    React.useEffect(() => {
        if (formDataInit && typeof formDataInit === 'object') {
            if (formDataInit.date && dateList.find(e => e.id == formDataInit.date)) handleDateChange(formDataInit.date)
            if (formDataInit.time) handleTimeChange(formDataInit.time)
            if (formDataInit.seats) handleSeatsChange(parseInt(formDataInit.seats))
        }
    }, [formDataInit, dateList])
    
    return <div className="offer-control__form">
        <div className="offer-control__row">
            
            <Select
                keyPrefix={'form'}
                items={dateList}
                value={dateValue}
                parentClass={'search-date search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                disabled={dateList.length === 1}
                error={!!errors.date}
                onChange={(value) => handleDateChange(value)}
            />

            <Select
                keyPrefix={'form'}
                items={timeList}
                value={timeValue}
                parentClass={'search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                error={!!errors.time}
                onChange={(value) => handleTimeChange(value)}
            />
            
            <SpinWidget
                className={'search-inputbox search-count'}
                value={seatsValue}
                minValue={1}
                maxValue={maxSeats}
                error={!!errors.seats}
                errorClass={'error_border'}
                onChange={(value) => handleSeatsChange(value)}
            />
        </div>
    </div>
}
